import angular from "angular";

import { CoreModule } from '../../core/core.module';
import { ActivityStepperComponent } from './activity-stepper/activity-stepper.component';
import { AddressSnippetComponent } from './address/address-snippet.component';
import { AddressController } from './address/AddressController';
import { CheckboxListComponent } from './checkbox-list/checkbox-list.component';
import { CheckboxListController } from './checkbox-list/CheckboxList';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LoadingSpinnerController } from './loading-spinner/loading-spinner';
import { CollapsibleSidebarModule } from "./collapsible-sidebar/collapsible-sidebar.module";
import { ColorModule } from "./color/color.module";

// Generic components that have no dependencies and can be reused anywhere.
export const ComponentsModule = angular
    .module("apex.common.components", [
        CoreModule, // A number of components make sure of core services.
        CollapsibleSidebarModule,
        ColorModule
    ])
    // Common components
    .component("apexActivityStepper", ActivityStepperComponent)
    .component("apexAddressSnippet", AddressSnippetComponent)
    .component("apexCheckboxList", CheckboxListComponent)
    .component("apexLoadingSpinner", LoadingSpinnerComponent)
    // Common component controllers (TODO: Replace with components where necessary)
    .controller("AddressController", AddressController)
    .controller("CheckboxListController", CheckboxListController)
    .controller("spinnerCtrl", LoadingSpinnerController)
    .name
